const publicBase = import.meta.env.BASE_URL.endsWith('/')
  ? import.meta.env.BASE_URL
  : `${import.meta.env.BASE_URL}/`;
const root = `${publicBase}skins/oro-mx-h5/jackpot`;

export const oroMxJackpotAssets = {
  bg: `${root}/bg.png`,
  bgClaim: `${root}/bg_claim.png`,
  bonusChip: `${root}/bonus.png`,
  claim: `${root}/button3.png`,
  claimDisabled: `${root}/button3_gray.png`,
  close: `${root}/close1.png`,
  details: `${root}/details1.png`,
  draw: `${root}/button1.png`,
  drawDisabled: `${root}/button1_grey.png`,
  finger: `${root}/finger.png`,
  popAmount: `${root}/pop_up/amount_bg.png`,
  popBg: `${root}/pop_up/bg.png`,
  popButton: `${root}/pop_up/button.png`,
  spin: `${root}/spin.png`,
  starLeft: `${root}/star_l.png`,
  starRight: `${root}/star_r.png`,
  taskBet: `${root}/bet.png`,
  taskBtn: `${root}/button4.png`,
  taskBtnDisabled: `${root}/button4_gray.png`,
  taskDeposit: `${root}/deposit.png`,
  taskLogin: `${root}/login.png`,
  trumpet: `${root}/trumpet.png`,
  vipBg: `${root}/vip_bg.png`,
  withdrawBg: `${root}/withdraw_bg.png`,
  vfx1: `${root}/CollectVFX/vfx1/vfx1.json`,
  vfx2: `${root}/CollectVFX/vfx2/vfx2.json`,
  vfx3: `${root}/CollectVFX/vfx3/vfx3.json`,
  vfx5: `${root}/CollectVFX/vfx5/vfx5.json`,
} as const;

/** 源站 2×2 货架：左上 GRAND、右上 MAJOR、左下 MINOR、右下 MINI。 */
export const JACKPOT_SHELF_ORDER = ['GRAND', 'MAJOR', 'MINOR', 'MINI'] as const;

export function jackpotShelfIndex(poolKey: string): number {
  const index = JACKPOT_SHELF_ORDER.indexOf(poolKey as (typeof JACKPOT_SHELF_ORDER)[number]);
  return index < 0 ? JACKPOT_SHELF_ORDER.length : index;
}

export function jackpotPoolLetters(poolKey: string): string[] {
  return [...poolKey];
}

/** 源站 light=已收集、dark=未收集。MINI 两个 I 共用同一张图。 */
export function jackpotLetterSrc(poolKey: string, letter: string, collected: boolean): string {
  const tone = collected ? 'light' : 'dark';
  return `${root}/${tone}_${poolKey}_${letter}.png`;
}

/** 源站履带只用发光球 `light/{pool}_{letter}.png`，与货架未收集的 dark 无关。 */
export function jackpotReelLetterSrc(poolKey: string, letter: string): string {
  return jackpotLetterSrc(poolKey, letter, true);
}
